import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "ion-padding-bottom" }
const _hoisted_4 = { class: "display-flex ion-justify-content-center item-text ion-text-capitalize" }
const _hoisted_5 = { class: "item-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_flashcard_icon = _resolveComponent("flashcard-icon")!
  const _component_policy_icon = _resolveComponent("policy-icon")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_light_mode_icon = _resolveComponent("light-mode-icon")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_menu = _resolveComponent("ion-menu")!

  return (_openBlock(), _createBlock(_component_ion_menu, {
    side: "start",
    "menu-id": _ctx.menuId,
    "content-id": _ctx.contentId
  }, {
    default: _withCtx(() => [
      _createElementVNode("view", _hoisted_1, [
        _createVNode(_component_ion_grid, { class: "display-grid" }, {
          default: _withCtx(() => [
            (_ctx.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 0,
                  class: "profile"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: _ctx.profilePictureUrl,
                      alt: `${_ctx.name}'s avatar`,
                      class: "rounded-circle ion-padding",
                      width: "120"
                    }, null, 8, _hoisted_2),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("strong", _hoisted_4, _toDisplayString(_ctx.name), 1),
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.username), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_ctx.isAuthenticated)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 1,
                  class: "intro"
                }, {
                  default: _withCtx(() => [
                    _cache[8] || (_cache[8] = _createElementVNode("img", {
                      src: "/assets/icon/firecracker-icon.svg",
                      alt: "Logo",
                      width: "100"
                    }, null, -1)),
                    _createVNode(_component_ion_title, { class: "item-text" }, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("strong", null, " Firecracker ", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_list, { lines: "none" }, {
                  default: _withCtx(() => [
                    (_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          button: "",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigate('/vocabularies')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: _ctx.faBook,
                              class: "menu-icon"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                _createTextVNode(" Vocabularies ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 1,
                          button: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigate('/leitner-systems')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_flashcard_icon, {
                              "fill-color-variable": '--ion-color-primary',
                              "stroke-color-variable": '--ion-color-primary',
                              class: "menu-icon"
                            }),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                _createTextVNode(" My Flashcards ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 2,
                          button: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigate('/guessing-game')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: _ctx.faBullseye,
                              class: "menu-icon"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode(" Guessing Word ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 3,
                          button: "",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigate('/cohort/read')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: _ctx.faUsers,
                              class: "menu-icon"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode(" My Cohort ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 4,
                          button: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigate('/sign-in')))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: _ctx.faSignInAlt,
                              class: "menu-icon"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode(" Sign In ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigate('/privacy-policy')))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_policy_icon, {
                          class: "menu-icon",
                          "fill-color-variable": '--ion-color-primary',
                          "stroke-color-variable": '--ion-item-background'
                        }),
                        _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                            _createTextVNode(" Privacy Policy ", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!(_ctx.isAuthenticated && !_ctx.isAndroid))
              ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }))
              : _createCommentVNode("", true),
            (!(_ctx.isAuthenticated && !_ctx.isAndroid))
              ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }))
              : _createCommentVNode("", true),
            (_ctx.isAuthenticated && !_ctx.isAndroid)
              ? (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_list, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_item, { class: "display-flex ion-align-items-end" }, {
                          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                            _createElementVNode("a", {
                              href: "https://play.google.com/store/apps/details?id=com.emtiajium.firecracker.collaborative.vocab.practice&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
                              target: "_blank",
                              class: "display-flex ion-justify-content-center"
                            }, [
                              _createElementVNode("img", {
                                alt: "Get it on Google Play",
                                src: "https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png",
                                class: "google-play"
                              })
                            ], -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_row, { class: "ion-align-items-end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_list, { lines: "none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleTheme()))
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.isDark)
                          ? (_openBlock(), _createBlock(_component_light_mode_icon, {
                              key: 0,
                              class: "menu-icon",
                              "fill-color-variable": '--ion-color-primary',
                              "stroke-color-variable": '--ion-color-primary'
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.isDark)
                          ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                              key: 1,
                              icon: _ctx.faMoon,
                              class: "menu-icon"
                            }, null, 8, ["icon"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Switch to " + _toDisplayString(_ctx.isDark ? 'Light' : 'Dark') + " Theme ", 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.isAuthenticated)
                      ? (_openBlock(), _createBlock(_component_ion_item, {
                          key: 0,
                          button: "",
                          onClick: _ctx.signOut
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, {
                              icon: _ctx.faSignOutAlt,
                              class: "menu-icon"
                            }, null, 8, ["icon"]),
                            _createVNode(_component_ion_label, { class: "ion-padding-start" }, {
                              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                _createTextVNode(" Sign Out ", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["menu-id", "content-id"]))
}